import { Link, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AdminShell } from "../layouts/AdminShell";

/** 404 inside the admin shell: the sidebar stays usable, the wrong URL is shown, and there is always a way out. */
export function NotFoundScreen() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  return (
    <AdminShell>
      <div className="flex min-h-[70vh] flex-col items-center justify-center px-6 text-center">
        <div className="text-[72px] font-black leading-none tracking-tight text-[#191c1d]">404</div>
        <h1 className="mt-4 text-xl font-black text-[#191c1d]">{t("notFound.title")}</h1>
        <p className="mt-2 max-w-md text-sm leading-6 text-[#534434]">{t("notFound.desc")}</p>
        <code className="mt-4 max-w-full break-all rounded-lg bg-[#f3f4f5] px-3 py-1 text-xs text-[#737373]">{pathname}</code>
        <div className="mt-7 flex flex-wrap justify-center gap-3">
          <Link to="/" replace className="rounded-xl bg-[#F07F3C] px-6 py-3 text-sm font-black text-white">{t("notFound.toDashboard")}</Link>
          <button type="button" onClick={() => navigate(-1)} className="rounded-xl border border-[#e0e3e5] bg-white px-6 py-3 text-sm font-bold text-[#191c1d]">{t("notFound.goBack")}</button>
        </div>
      </div>
    </AdminShell>
  );
}
